export default {
  'corporateProducts': ['#FE5B00', '#CE4A00'],
  'corporateCompany': ['#0055FF', '#264187'],
  'corporateSales': ['#3AD4A7','#00BA77'],
}

